module.exports = __webpack_public_path__ + "static/media/title_tumitate.799ff21a.svg";